import { SET_SALESPERSON_ID } from "../action";

export function setSalesPersonId(userId) {
  return (dispatch) => {
    dispatch({ type: SET_SALESPERSON_ID, payload: userId });
  };
}
